import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ProductService } from '../product.service';

@Component({
  selector: 'app-new-product-smart',
  template: '<app-new-product [pricelists]="pricelists" [producttypes]="producttypes" [plantypes]="plantypes" [providerService]="providerService"  [transactionTypes]="transactionTypes" [codeGroups]="codeGroups" [carrierTypes]="carrierTypes" [serviceCountries]="serviceCountries" [responseTypes]="responseTypes"></app-new-product>',
  styles: [
  ]
})
export class NewProductSmartComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  // providers: any;
  producttypes: any;
  plantypes: any;
  providerService: any;
  transactionTypes: any;
  codeGroups: any;
  carrierTypes: any;
  serviceCountries: any;
  responseTypes:any;
  pricelists:any;

  constructor(private productService: ProductService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit()


    // // Provider names
    // this.productService.getallproviders().subscribe(
    //   res => {
    //     let _providers: any = res;
    //     if (_providers.httpcode == 200) {
    //       this.providers = _providers.data;
    //      
    //     }
    //   }
    // );
    // Product type
    this.productService.getallproducttypes().subscribe(
      res => {
        let data: any = res;
        if (data.httpcode == 200) {
          this.producttypes = data.data;
          //;

        }
      }
    );
    // plan type
    this.productService.getallplantypes().subscribe(
      res => {
        let _plantypes: any = res;
        if (_plantypes.httpcode == 200) {
          this.plantypes = _plantypes.data;
          //;
          //;

        }
      }
    );
    // Provider Service
    this.productService.getallProviderService().subscribe(
      res => {
        let _providerService: any = res;
        if (_providerService.httpcode == 200) {
          this.providerService = _providerService.data;
         

        }
      }
    );

    //service country
    this.productService.getserviceCountry().subscribe(
      res => {
        let _serviceCountries: any = res;
        if (_serviceCountries.httpcode == 200) {
          this.serviceCountries = _serviceCountries.data;
         

        }
      }
    );
    //transaction type
    this.productService.getTransactionTypes().subscribe(
      res => {
        let _transactionTypes: any = res;
        if (_transactionTypes.httpcode == 200) {
          this.transactionTypes = _transactionTypes.data;
         

        }
      }
    );
    //responseTypes
    this.productService.getallresponseTypes().subscribe(
      res => {
        let _responseTypes: any = res;
        if (_responseTypes.httpcode == 200) {
          this.responseTypes = _responseTypes.data;
         

        }
      }
    );
    //codeGroup
    this.productService.getcodeGroups().subscribe(
      res => {
        let _codeGroups: any = res;
        if (_codeGroups.httpcode == 200) {
          this.codeGroups = _codeGroups.data;
         
        }
      }
    );

    //carrier
    this.productService.getCarriers().subscribe(
      res => {
        let _carrierTypes: any = res;
        if (_carrierTypes.httpcode == 200) {
          this.carrierTypes = _carrierTypes.data;
         

        }
      }
    );
      // pricelists names
      this.productService.getAllPricelistnametype().subscribe(
        res => {
          let _pricelists: any = res;
          if (_pricelists.httpcode == 200) {
            this.pricelists = _pricelists.data;
           
          }
        }
      );  

  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }
  
}
